function mat4LookAtWorldLHToRef(out, eye, target, up) {
  out[3] = 0;
  out[7] = 0;
  out[11] = 0;
  out[12] = eye.x;
  out[13] = eye.y;
  out[14] = eye.z;
  out[15] = 1;
  let zx = target.x - eye.x;
  let zy = target.y - eye.y;
  let zz = target.z - eye.z;
  const zLen = Math.sqrt(zx * zx + zy * zy + zz * zz);
  let xx = 0;
  let xy = 0;
  let xz = 0;
  let xLen = 0;
  if (zLen >= 1e-10) {
    const invZ = 1 / zLen;
    zx *= invZ;
    zy *= invZ;
    zz *= invZ;
    xx = up.y * zz - up.z * zy;
    xy = up.z * zx - up.x * zz;
    xz = up.x * zy - up.y * zx;
    xLen = Math.sqrt(xx * xx + xy * xy + xz * xz);
  }
  if (xLen < 1e-10) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    return;
  }
  const invX = 1 / xLen;
  xx *= invX;
  xy *= invX;
  xz *= invX;
  out[0] = xx;
  out[1] = xy;
  out[2] = xz;
  out[4] = zy * xz - zz * xy;
  out[5] = zz * xx - zx * xz;
  out[6] = zx * xy - zy * xx;
  out[8] = zx;
  out[9] = zy;
  out[10] = zz;
}

export { mat4LookAtWorldLHToRef };
//# sourceMappingURL=mat4-look-at-world-lh.js.map
